import React from 'react';
import {NotificationsList} from 'features/notifications';
import styles from './NotificationsPage.module.css';

export function NotificationsPage(): React.ReactElement {
	return (
		<div className={styles.root}>
			<header className={styles.header}>
				<h1 className={styles.title}>Уведомления</h1>
			</header>
			<div className={styles.content}>
				<div className={styles.contentInner}>
					<NotificationsList />
				</div>
			</div>
		</div>
	);
}
